import linkedin from "../images/linkedin.svg";
import github from "../images/github.svg";
import mail from "../images/mail.svg";
import activision from "../images/logos/Activision-Logo.png";
import raven from "../images/logos/Raven_Software_logo.png";
import treyarch from "../images/logos/treyarch_logo.png";
import nasa from "../images/logos/nasa.png";

const experience = [
  {
    company: "Treyarch (Activision)",
    role: "Graphics Engineering Intern",
    year: "June 2026 - September 2026",
    logos: [{ source: treyarch, alt: "Treyarch logo" }],
    description:
      "Worked on Call of Duty graphics features across post-processing and various things!",
    images: [],
  },
  {
    company: "Raven Software (Activision)",
    role: "Graphics Engineering Intern",
    year: "May 2025 - August 2025",
    logos: [{ source: raven, alt: "Raven Software logo" }],
    link: "https://www.ravensoftware.com/",
    description:
      "Worked on, profiled, and optimized shaders for future game modes, learning professional GPU performance tools such as PIX and Razor GPU across PS5, Xbox, and PC.\n Credited on Black Ops 7.",
    images: [],
  },
  {
    company: "NASA Goddard Space Flight Center",
    role: "Research Intern",
    year: "June 2024 - August 2024",
    logos: [{ source: nasa, alt: "NASA logo" }],
    description:
      "Worked on volume rendering applications for VALIXR, an XR 3D data-visualization tool in Unity.",
    images: [],
  },
];

function About() {
  return (
    <div>
      <div id="projectFX">
        <div className="mt-4">
          I'm Anthony Ge, a master's student at the University of Pennsylvania
          studying Computer Graphics and Game Technology. I graduated in spring
          2026 with my bachelor's in Digital Media Design. I focus on graphics
          programming for real-time applications, with an emphasis on GPU
          programming.
          <div className=" w-full h-px mx-auto my-4 bg-black"></div>
          <section aria-labelledby="experience-heading">
            <h2 id="experience-heading" className="text-2xl font-semibold mb-5">
              Experience
            </h2>
            <div className="">
              {experience.map((job) => (
                <article
                  key={`${job.company}-${job.year}`}
                  className="border-b border-black py-6 first:pt-0 last:border-b-0 last:pb-2"
                >
                  <div className="grid gap-5 md:grid-cols-[15rem_minmax(0,48rem)]">
                    <div className="flex min-h-24 flex-col items-center justify-center gap-2">
                      {job.logos.map((logo) => (
                        <img
                          key={logo.alt}
                          src={logo.source}
                          alt={logo.alt}
                          className="max-h-16 w-full object-contain"
                        />
                      ))}
                    </div>
                    <div className="max-w-3xl">
                      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                        <h3 className="text-xl font-semibold">
                          {job.link ? (
                            <a
                              href={job.link}
                              className="hover:opacity-60 duration-200"
                            >
                              {job.company}
                            </a>
                          ) : (
                            job.company
                          )}
                        </h3>
                        <span className="text-lg font-semibold">
                          {job.year}
                        </span>
                      </div>
                      <p className="mt-1 italic opacity-70">{job.role}</p>
                      <p className="mt-3 leading-relaxed">{job.description}</p>
                      {job.images.length > 0 ? (
                        <div className="mt-5 grid gap-3 sm:grid-cols-2">
                          {job.images.map((image, imageIndex) => (
                            <img
                              key={`${job.company}-image-${imageIndex}`}
                              src={image}
                              alt={`${job.company} supplemental ${imageIndex + 1}`}
                              className="h-36 w-full rounded-md object-cover shadow-sm"
                            />
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>
          <div className=" w-full h-px mx-auto my-4 bg-black"></div>
        </div>

        <div className="flex mt-4 py-4 space-x-10" id="">
          <div className="flex space-x-2">
            <a href="https://www.linkedin.com/in/anthonyge/">
              <img
                src={linkedin}
                alt="linkedin"
                className="w-[3em] bg-white rounded-lg p-[2px] hover:opacity-50 duration-300"
              />
            </a>
            <a href="https://www.github.com/geant04">
              <img
                src={github}
                alt="github"
                className="w-[3em] bg-white rounded-full p-[2px] hover:opacity-50 duration-300"
              />
            </a>
            <a href="mailto::geant@seas.upenn.edu">
              <img
                src={mail}
                alt="mail"
                className="w-[3em] bg-white rounded-full p-[2px] hover:opacity-50 duration-300"
              />
            </a>
          </div>
        </div>

        {/*
                <div className=" w-full h-px mx-auto my-4 bg-black"></div>
                <div className="">
                    <h1>Graphics Programming Demo Reel</h1>
                    <br></br>
                    <div className="projectFX bg-blue" id="projectFX">
                        <div className="md:w-[75%] lg:w-[65%]">
                            <iframe src="https://player.vimeo.com/video/899942080?h=effef4f596"
                            className="w-full aspect-video" frameborder="0" allow="autoplay; fullscreen" title="demo" allowfullscreen></iframe>
                        </div>
                    </div>
                    <br></br>
                </div>

                <div className="mb-8">
                    Learn more about my projects in motion + breakdowns!
                </div>

                <div className=" w-full h-px mx-auto my-4 bg-black"></div>
                <h1>More Info</h1>

                <div className="mt-4 mb-16">
                    Artstation: <a href="https://www.artstation.com/geant">  
                    <span class="w-[3em] bg-white rounded-full p-[2px] hover:opacity-50 duration-300">
                     https://www.artstation.com/geant
                    </span>
                    </a>
                </div>
                 */}
      </div>
    </div>
  );
}

export default About;
